import { render, staticRenderFns } from "./specialNfcOrder.vue?vue&type=template&id=188a5c81&scoped=true"
import script from "./specialNfcOrder.vue?vue&type=script&lang=js"
export * from "./specialNfcOrder.vue?vue&type=script&lang=js"
import style0 from "./specialNfcOrder.vue?vue&type=style&index=0&id=188a5c81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188a5c81",
  null
  
)

export default component.exports